import { NgModule } from '@angular/core';
import { DecimalPipe, DecimalService } from './decimal.pipe';

const PIPES = [
  DecimalPipe
],

 SERVICES = [
  DecimalService
];

@NgModule({
  declarations: PIPES,
  exports: PIPES,
  providers: SERVICES
})
export class PipesModule {
}
